module.exports = __webpack_public_path__ + "img/share-icon.92d1b9cc.svg";